import { render, staticRenderFns } from "./patrolPoint.vue?vue&type=template&id=fec67ed8&scoped=true&"
import script from "./patrolPoint.vue?vue&type=script&lang=ts&"
export * from "./patrolPoint.vue?vue&type=script&lang=ts&"
import style0 from "./patrolPoint.vue?vue&type=style&index=0&id=fec67ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec67ed8",
  null
  
)

export default component.exports